import { Injectable } from '@angular/core';
import { AlertController } from "ionic-angular";

////////////////////////////////////..........
///// Alert Service 
///// 用途 Ionicアラートの表示制御
///// 当Serviceを通すことで連続表示を制御する
////////////////////////////////////..........

@Injectable()
export class AlertService {

  isShowModal: boolean;

  constructor(
    private alertCtrl: AlertController,
  ) {
    this.isShowModal = false;
  }

  /**
   * アラート表示
   * @param title 
   * @param subTitle 
   * @param handler 
   */
  basic(title: string, message: string, handler: any): void {
    if (this.isShowModal) return;
    this.isShowModal = true;

    let alert = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [{
        text: 'OK',
        cssClass: 'confirm-button',
        handler: () => {
          handler();
          this.isShowModal = false;
        }
      }],
      enableBackdropDismiss: false,
      cssClass: 'custom-alert'
    });
    alert.present();
  }

  /**
   * 確認アラート表示
   * @param title 
   * @param subTitle 
   * @param handler 
   */
  confirm(title: string, message: string, handler: any, ngHandler: any = ()=>{}): void {
    if (this.isShowModal) return;
    this.isShowModal = true;

    let alert = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'cancel-button',
          handler: () => {
            console.log('Cancel')
            if(ngHandler) {
              ngHandler();
            }
            this.isShowModal = false;
          }
        },
        {
          text: 'OK',
          cssClass: 'ok-button',
          handler: () => {
            handler();
            this.isShowModal = false;
          }
        }
      ],
      enableBackdropDismiss: false,
      cssClass: 'custom-alert'
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/providers/alert.service.ts